module.exports = __webpack_public_path__ + "static/media/bizzey.8300135d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/clients/bizzey.jpg
// module id = 284
// module chunks = 0